
<div class="modal-body">
  <div class="form-group" *ngIf="loading">
    <spinner [text]="'Scanning for other backups'|translate"></spinner>
  </div>
  <div class="form-group" *ngIf="!loading">
    <label translate>Restore from following backups:</label>
    <entity-list [entities]="entries" [sortEntityPaths]="[&quot;tape.name&quot;]" [selection]="selection">
      <ng-template entityListItem let-entry="entity">
        <div class="list-group-item list-group-item-action d-flex align-items-center no-wrap" (click)="selection.toggle(entry)"><i class="far fa-tape"></i><span>{{entry.tape.name}} {{entry.path}}</span></div>
      </ng-template>
    </entity-list>
  </div>
</div>
<div class="modal-footer" *ngIf="!loading">
  <button class="btn btn-outline-primary" (click)="enqueue()" [disabled]="selection.isEmpty()" translate>Enqueue</button>
  <button class="btn btn-outline-secondary" (click)="cancel()" translate>Cancel</button>
</div>